import styled from "styled-components";
import React from "react"; 

import {startCase} from "lodash";
import { ReturnToProductModalV2Data } from "./ReturnToProductModal";

const ProductsPanel = styled.div`
    display: flex; /* Add this line to enable flexbox */
    flex-direction: column; /* Arrange children in a column */
    align-items: flex-start;
    background-color: #FFFFFF;
    border: 1px #505258 solid;
    border-radius: 4px;
    position: relative;
    width: 359px;

  .orange-block {
    inset-block-end: -24px;
    inset-inline-end: -8px;
    position: absolute;
    z-index: -2;
  }

  p {
    margin: 16px !important;
  }
`;

const CTAContentContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 8px;
  position: relative;
  z-index: 2;
  width: 100%;
  padding: 12px;

  .one-product {
        visibility: visible;
        
    }

    .multiple-products {
        visibility: hidden;
        transition: "opacity 0.1s ease-in-out";
    }

    &:hover .multiple-products {
        visibility: visible;
        transition: visibility 0.1s;
      }
`;

const SiteContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 2px;
  justify-self: flex-start;
  overflow: hidden;
  position: relative;
  text-overflow: ellipsis;
  white-space: nowrap;

  .productName {
    font-size: 16px;
    font-weight: 500;
    line-height: 100%;
    font-family: Charlie Display, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Noto Sans, Ubuntu, Droid Sans, Helvetica Neue, sans-serif !important;
    }

    .siteName {
        color: #505258;
        font-size: 12px;
        font-weight: 300;
        line-height: normal;
        text-align: left;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        flex-grow: 1;
    }
`;

const ButtonContainer = styled.div`
    flex-direction: column;
    align-items: center;

    .modal-cta-button {
        border-radius: 40px;
        width: 70px;
        height: 36px;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        background-color: #1868db;
        border: 1.5px solid #1868db;
    }
`

const pathDataOptions = {
    1: "M2.22308 8.26983L325.41 0.496637L329.402 57.4844L0.0999442 60.9428L2.22308 8.26983Z", // Original
    2: "M2.22308 16.53966L325.41 0.993274L329.402 114.9688L0.0999442 121.8856L2.22308 16.53966Z", // Double
    3: "M2.22308 24.80949L325.41 1.489911L329.402 172.4532L0.0999442 182.8284L2.22308 24.80949Z" // Triple
};

export interface ReturnToProductCTAPropsV2 {
    products: ReturnToProductModalV2Data[];
}

const calculateRect2Height = (products: ReturnToProductModalV2Data[]) => {
    if (products.length === 1) {
        return 47;
    }
    if (products.length === 2) {
        return 94;
    }
    if (products.length === 3) {
        return 141;
    }
    return 47;
};

const ReturnToProductModalCTA = ({
    products = []
}: ReturnToProductCTAPropsV2) => {

    const pathData =
        pathDataOptions[products.length as keyof typeof pathDataOptions] ||
        pathDataOptions[1];
    const svgHeight = calculateRect2Height(products);

    return (
        <ProductsPanel> 
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="302"
                height={svgHeight}
                viewBox={`0 0 302 ${svgHeight}`}
                fill="none"
                className="orange-block"
            >
                <path d={pathData} fill="#FFA900" />
            </svg>
            {products.map(
                ({ productName, siteName, productMark, ctaButton }, index) => (
                    <CTAContentContainer key={index}>
                        {productMark}
                        <SiteContainer>
                            <span className="productName">
                                {startCase(productName)}
                            </span>
                            <span className="siteName">{siteName}</span>
                        </SiteContainer>
                        <ButtonContainer className={`${products.length === 1 ? 'one-product' : 'multiple-products'}`}>
                            {ctaButton}
                        </ButtonContainer>
                    </CTAContentContainer>
                
                )
            )}
        </ProductsPanel>
    );
};

export default ReturnToProductModalCTA;